import type { CSSProperties, ReactNode } from 'react';
import type { Frame } from '../data/types';

const panel: CSSProperties = {
  position: 'fixed',
  top: 16,
  left: 16,
  padding: '10px 14px',
  borderRadius: 8,
  background: 'rgba(12, 16, 22, 0.72)',
  color: '#e6edf3',
  font: '13px/1.5 system-ui, sans-serif',
  letterSpacing: 0.2,
  backdropFilter: 'blur(6px)',
  border: '1px solid rgba(255,255,255,0.08)',
  pointerEvents: 'none',
  userSelect: 'none',
};

/** Centered message overlay (loading / error states). */
export function Overlay({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'grid',
        placeItems: 'center',
        color: '#e6edf3',
        font: '14px system-ui, sans-serif',
        pointerEvents: 'none',
      }}
    >
      <div style={{ ...panel, position: 'static' }}>{children}</div>
    </div>
  );
}

/** Small info panel showing what the current frame contains. */
export function Hud({ frame }: { frame: Frame }) {
  return (
    <div className="hud-panel" style={panel}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>PandaSet Viewer</div>
      <div>frame {frame.id}</div>
      <div>{frame.pointCount.toLocaleString()} points</div>
      <div>{frame.cuboids.length} cuboids</div>
    </div>
  );
}
